<template>
  <div
    v-loading="loading"
    class="l-page l-page--search"
  >
    <div class="l-page__header c-page__header">
      <h2
        v-menu-title
        class="c-page__header-title"
      >
        人员签到信息
      </h2>
      <div class="c-page__header-btns">
        <k-button
          btn-text="查询"
          :auth-type="false"
          type="primary"
          icon="kestrel-icon ki-search"
          @click="search"
        />
        <k-button
          btn-text="重置"
          :auth-type="false"
          icon="kestrel-icon ki-repeat"
          @click="reset"
        />
      </div>
    </div>
    <div class="l-page__item l-page--search__item">
      <hm-page-card
        title="查询条件"
        class="c-card--condition"
      >
        <el-form
          ref="filterForm"
          :model="filter"
          :inline="true"
          class="c-form c-condition__form"
          label-width="90px"
          label-suffix="："
        >
          <el-row class="c-form__row">
            <el-col
              class="c-form__col"
              :span="12"
            >
              <el-form-item
                class="c-form__item"
                label="评估项目"
                prop="xmId"
              >
                <el-select
                  v-model="filter.xmId"
                  filterable
                  clearable
                  style="width: 100%;"
                  placeholder="请选择评估项目"
                >
                  <el-option
                    v-for="item in projects"
                    :key="item.xmId"
                    :label="item.xmmc"
                    :value="item.xmId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="签到人员"
                prop="qdrMc"
              >
                <el-input
                  v-model.trim="filter.qdrMc"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </hm-page-card>
    </div>
    <div class="l-page__body l-page--search__body">
      <el-tabs
        type="border-card"
        class="l-page__tabs l-page__tabs--single"
      >
        <el-tab-pane label="签到记录">
          <k-table
            height="100%"
            :table-column="columns"
            :data="rows"
            :pagination-show="false"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { pgxmManageService } from '../pgxm/pgxm.service';

export default {
  name: 'JxxfRyqdxxManage',
  data () {
    return {
      loading: false,
      projects: [],
      sourceRows: [],
      filter: {
        xmId: this.$route.params.xmId || '',
        qdrMc: ''
      },
      columns: [
        { key: 'index', label: '序号', width: '65', align: 'center', type: 'index' },
        { key: 'qdrMc', label: '签到人员', minWidth: '130', align: 'left', type: 'text' },
        { key: 'qdsj', label: '签到时间', width: '170', align: 'center', type: 'dateTime' },
        { key: 'qddz', label: '签到地址', minWidth: '240', align: 'left', type: 'text' },
        { key: 'jd', label: '经度', width: '120', align: 'center', type: 'text' },
        { key: 'wd', label: '纬度', width: '120', align: 'center', type: 'text' },
        { key: 'jl', label: '距项目距离（米）', width: '145', align: 'center', type: 'text' },
        { key: 'qdzt', label: '签到状态', width: '110', align: 'center', type: 'text' },
        { key: 'bz', label: '备注', minWidth: '160', align: 'left', type: 'text' }
      ]
    };
  },
  computed: {
    rows () {
      const keyword = this.filter.qdrMc.toLowerCase();
      return this.sourceRows.filter(item =>
        !keyword || (item.qdrMc || '').toLowerCase().includes(keyword)
      );
    }
  },
  methods: {
    loadProjects () {
      return pgxmManageService.query({ pageNo: 1, pageSize: 1000 }).then(rsp => {
        this.projects = rsp.data.rows || [];
      });
    },
    search () {
      if (!this.filter.xmId) {
        this.sourceRows = [];
        this.$message.info('请先选择评估项目');
        return;
      }
      this.loading = true;
      pgxmManageService.signIns(this.filter.xmId).then(rsp => {
        this.sourceRows = rsp.data || [];
      }).finally(() => {
        this.loading = false;
      });
    },
    reset () {
      this.$refs.filterForm.resetFields();
      this.sourceRows = [];
    }
  },
  created () {
    this.loading = true;
    this.loadProjects().then(() => {
      if (this.filter.xmId) return pgxmManageService.signIns(this.filter.xmId);
      return { data: [] };
    }).then(rsp => {
      this.sourceRows = rsp.data || [];
    }).finally(() => {
      this.loading = false;
    });
  }
};
</script>
